import { render, staticRenderFns } from "./index.vue?vue&type=template&id=109a6d4a&scoped=true"
import script from "./entity-details?vue&type=script&lang=js&external"
export * from "./entity-details?vue&type=script&lang=js&external"
import style0 from "./index.vue?vue&type=style&index=0&id=109a6d4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "109a6d4a",
  null
  
)

export default component.exports